import React from "react";
import "./GsoCarAccidentInfographic.css";

/**
 * GSO "What to Do After a Car Accident" infographic section.
 * Recreated from gaspineortho.com data-id="257013d":
 *   heading + infographic image (with icons/steps baked in).
 * Rendered with our neumorphic frame.
 */
export default function GsoCarAccidentInfographic() {
  return (
    <section
      className="gso-car-accident-infographic section-padding"
      role="region"
      aria-labelledby="gso-car-accident-ig-heading"
    >
      <div className="container">
        <h2
          id="gso-car-accident-ig-heading"
          className="gso-car-accident-infographic__heading"
        >
          What to Do After a Car Accident
        </h2>
        <div className="gso-car-accident-infographic__frame">
          <img
            src="/assets/brand/gso/infographics/what-to-do-after-car-accident.webp"
            alt="Step-by-step infographic showing what to do after a car accident — call 911, document the scene, see a doctor, contact a lawyer"
            loading="lazy"
            width="800"
            height="592"
          />
        </div>
      </div>
    </section>
  );
}
